import { ReactNode } from 'react';

import {
  DropdownListMenuHolder,
  DropdownListMenuList,
} from './DropdownListMenu.styled';

type Props = {
  width: number;
  maxHeight?: number | string;
  children: ReactNode;
  qaId: string;
};

export function DropdownListMenu({ width, maxHeight, children, qaId }: Props) {
  return (
    <DropdownListMenuHolder data-qa-id={qaId}>
      <DropdownListMenuList $width={width} $maxHeight={maxHeight}>
        {children}
      </DropdownListMenuList>
    </DropdownListMenuHolder>
  );
}
